export { default } from './AccommodationRoomType'
